import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const BlankTemplate = ({
  height = 80,
  width = 72,
  color = colors.white,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} {...props}>
    <rect
      x="0.5"
      y="0.5"
      width="70.1111"
      height="79"
      rx="3.5"
      fill={getColor(color, isColorInherited)}
      stroke="white"
    />
  </SvgIcon>
);
